import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1,Text3,Text4 } from '../../../styles';
import { Button } from 'antd';


const DeactivateMerchantModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Deactivate Merchant
            </Text1>
        )
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={() => props.toggleDeactivateModal()}
            centered
            hideFooter
            destroyOnClose
        >
            {/* {renderTitle()} */}
            <Text4 className="d-block mb-4">Are you sure you want to deactivate this merchant?</Text4>
            <div className="mt-4 d-flex justify-content-end">
                <Button className="mr-1" onClick={props.toggleDeactivateModal}>Cancel</Button>
                <Button type="danger" loading={props.loading} onClick={() => props.deactivate_submerchant(props?.merchant?.id)}>Yes, Deactivate</Button>
            </div>
        </EaseModal>
    )
};

export { DeactivateMerchantModal };